<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div v-if="winnerSaveMessage === null">
                    <div class="form-group">
                        <label for="campaignNameInput1">
                            Campaign Name
                        </label>
                        <input type="text" class="form-control" id="campaignNameInput1" v-model="submission.campaignName" readonly/>
                    </div>
                    <div class="form-group">
                        <label for="siteInput">
                            Site
                        </label>
                        <input type="text" class="form-control" id="siteInput" v-model="submission.site" readonly/>
                    </div>
                    <div class="form-group">
                        <label for="firstNameInput">
                            First Name
                        </label>
                        <input type="text" class="form-control" id="firstNameInput" v-model="submission.firstName" readonly/>
                    </div>
                    <div class="form-group">
                        <label for="lastNameInput">
                            Last Name
                        </label>
                        <input type="text" class="form-control" id="lastNameInput" v-model="submission.lastName" readonly/>
                    </div>
                    <div class="form-group">
                        <label for="mobileNumberInput">
                            Mobile Number
                        </label>
                        <input type="text" class="form-control" id="mobileNumberInput" v-model="submission.mobileNumber" readonly/>
                    </div>
                    <div class="form-group">
                        <label for="emailInput">
                            Email
                        </label>
                        <input type="text" class="form-control" id="emailInput" v-model="submission.emailAddress" readonly/>
                    </div>
                    <div class="form-group">
                        <label for="cardNumberInput">
                            Card Number
                        </label>
                        <input type="text" class="form-control" id="cardNumberInput" v-model="submission.cardNumber" readonly/>
                    </div>
                    <div class="form-group">
                        <label for="loyaltyMemberInput">
                            Is Loyalty Member?
                        </label>
                        <input type="text" class="form-control" id="loyaltyMemberInput" v-model="submission.isLoyalCustomer" readonly/>
                    </div>
                    <div class="form-group">
                        <label for="winningMemberInput">
                            Is Winner?
                        </label>
                        <input type="text" class="form-control" id="winningMemberInput" v-model="submission.isWinner" readonly/>
                    </div>
                    <div class="form-group">
                        <label for="winnerApprovedOnInput">
                            Winner Approved On
                        </label>
                        <input type="text" class="form-control" id="winnerApprovedOnInput" v-model="submission.winnerApprovedOn" readonly/>
                    </div>
                    <div class="form-group">
                        <label>
                           File Upload
                        </label>
                        <br>
                        <button class="btn btn-link" @click="downloadSubmissionTillSlip">Till Slip</button>
                    </div>
                </div>
                <h4 v-if="winnerSaveMessage !== null && winnerSaveMessage !== ''">
                    {{winnerSaveMessage}}
                </h4>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="addOrUpdateCampaignWinner(true)" :disabled="loading"
                        v-if="submissionIsDrawnWinner && winnerSaveMessage === null">Approve Winner</button>
                <button type="button" class="btn btn-info" @click="addOrUpdateCampaignWinner(false)" :disabled="loading"
                        v-if="submissionIsDrawnWinner && winnerSaveMessage === null">Reject Winner</button>
                <button type="button" class="btn btn-secondary" @click="onModalCloseClick" :disabled="loading"
                        v-if="winnerSaveMessage === null">Close</button>
                
                <button type="button" class="btn btn-secondary" @click="onModalCloseClick" :disabled="loading"
                        v-if="winnerSaveMessage !== null && !winnerRejected">OK</button>
                
                <button class="btn btn-primary" v-if="winnerRejected" @click="redrawWinner">
                    Yes
                </button>
                <button class="btn btn-secondary" v-if="winnerRejected" @click="onModalCloseClick">
                    No
                </button>
            </div>
        </div>
    </div>
</div>